import { isInAppBrowser } from '../../utils/config/browserUtils';
import { isLoginWithSupportPassword, isUserAdmin, isUserLoggedIn } from '../../utils/function';

/** Logged-in, non-admin users in a normal browser (not in-app WebView). */
export const canSyncPushNotifications = () =>
  !isInAppBrowser() &&
  isUserLoggedIn() &&
  !isUserAdmin() &&
  !isLoginWithSupportPassword();
